// extracted by mini-css-extract-plugin
export default {"notice-wrapper":"notice_style_notice-wrapper__LTpXt","icon-color":"notice_style_icon-color__OP4mf"};